type UploadBucket = {
  file: File;
  url: string;
  fields?: Record<string, string>;
  bucket?: BucketType;
  fileName?: string;
};

export type BucketType =
  | 'notes-images-unriddle'
  | 'convert-unriddle'
  | 'chat-book'
  | 'unriddle-media';

export const uploadBucket = async ({ file, url }: UploadBucket) => {
  await fetch(url, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });

  return url;
};

export const uploadBucketGoogle = async ({
  fields,
  file,
  url,
  bucket,
  fileName,
}: UploadBucket) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries({ ...fields, file })) {
    formData.append(key, value);
  }

  await fetch(url, {
    method: 'POST',
    body: formData,
  });

  return `https://storage.googleapis.com/${bucket}/${fileName}`;
};
